/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import useT, {
    UseTranslationOptions,
} from "../../../Basis/Internationalisierung/Hooks/useTranslation";
import i18n from "../../../Basis/Internationalisierung/i18n";
import { Mitteilungsarten } from "../Queries/Mitteilungsart";

export const useTranslation = (options?: UseTranslationOptions) => useT("i18nMitteilungen", options);
export const fixedT = i18n.getFixedT(null, "i18nMitteilungen");

export const translationKeys = {
    dialogMitteilungen: {
        schliessen: "dialogMitteilungen.schliessen",
        nichtMehrAnzeigen: "dialogMitteilungen.nichtMehrAnzeigen",
        mitteilung: "dialogMitteilungen.mitteilung",
        von: "dialogMitteilungen.von",
        vorherigeMitteilung: "dialogMitteilungen.vorherigeMitteilung",
        naechsteMitteilung: "dialogMitteilungen.naechsteMitteilung",
    },
    mitteilungenView: {
        mitteilungen: "mitteilungenView.mitteilungen",
        anlegen: "mitteilungenView.anlegen",
        bezeichnung: "mitteilungenView.bezeichnung",
        art: "mitteilungenView.art",
        anzeigenVon: "mitteilungenView.anzeigenVon",
        anzeigenBis: "mitteilungenView.anzeigenBis",
        bearbeiten: "mitteilungenView.bearbeiten",
        loeschen: "mitteilungenView.loeschen"
    },
    mitteilungenBreadcrumb: {
        mitteilungen: "mitteilungenBreadcrumb.mitteilungen",
    },
    mitteilungsart: {
        banner: "mitteilungsart.banner",
        dialog: "mitteilungsart.dialog",
    },
    legeMitteilungAnDialog: {
        dialogCaption: "legeMitteilungAnDialog.dialogCaption",
        dialogText: "legeMitteilungAnDialog.dialogText",
        details: "legeMitteilungAnDialog.details",
        art: "legeMitteilungAnDialog.art",
        bezeichnung: "legeMitteilungAnDialog.bezeichnung",
        abbrechen: "legeMitteilungAnDialog.abbrechen",
        anlegen: "legeMitteilungAnDialog.anlegen",
        text: "legeMitteilungAnDialog.text",
        anzeigenVon: "legeMitteilungAnDialog.anzeigenVon",
        anzeigenBis: "legeMitteilungAnDialog.anzeigenBis",
    },
    aendereMitteilungDialog: {
        dialogCaption: "aendereMitteilungDialog.dialogCaption",
        dialogText: "aendereMitteilungDialog.dialogText",
        details: "aendereMitteilungDialog.details",
        art: "aendereMitteilungDialog.art",
        bezeichnung: "aendereMitteilungDialog.bezeichnung",
        abbrechen: "aendereMitteilungDialog.abbrechen",
        aendern: "aendereMitteilungDialog.aendern",
        text: "aendereMitteilungDialog.text",
        anzeigenVon: "aendereMitteilungDialog.anzeigenVon",
        anzeigenBis: "aendereMitteilungDialog.anzeigenBis",
    },
    loescheMitteilungenDialog: {
        dialogCaption: "loescheMitteilungenDialog.dialogCaption",
        dialogText: "loescheMitteilungenDialog.dialogText",
        coffeeMugText: "loescheMitteilungenDialog.coffeeMugText",
    }
};

export const mitteilungsartTranslationKeys = {
    [Mitteilungsarten.banner]: translationKeys.mitteilungsart.banner,
    [Mitteilungsarten.dialog]: translationKeys.mitteilungsart.dialog,
};